const decimalFormatting = (num: Number) => {
  const [whole, fraction] = num.toFixed(2).split('.');
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${formattedWhole},${fraction}`;
};

export default decimalFormatting;
